import { DailyRewardPackageCode } from 'config/constants/dailyReward'
import { DailyRewardPackage } from 'config/types/bonus/DailyReward'
import Column from 'layout/Components/Column'
import { RowBetween, RowCenter } from 'layout/Components/Row'
import React from 'react'
import { Trans } from 'react-i18next'
import theme from 'theme'
import colors from 'theme/ui/colors'
import Box from 'UIKit/Box/Box'
import Image from 'UIKit/Image'
import Tab from 'UIKit/Tab'
import Text from 'UIKit/Text'

type PackageTabsProps = {
  parsedPackages: (DailyRewardPackage & { isWaitingClaim: boolean })[]
  activeCode: DailyRewardPackageCode
  onChange: (code: DailyRewardPackageCode) => void
}

const PackageTabs: React.FC<PackageTabsProps> = ({ activeCode, onChange, parsedPackages }) => {
  return (
    <Box
      mt={theme.spacing.fix_200}
      p={theme.spacing.fix_050}
      background={theme.colors.bg_surface_secondary}
      width="100%"
      borderRadius={theme.radii.radius_lg}
    >
      <RowCenter>
        {parsedPackages?.map((item) => {
          return (
            <Tab
              value={item.code}
              onTagChanged={() => {
                onChange(item.code)
              }}
              width="50%"
              key={item.code}
            >
              <RowCenter
                background={activeCode === item.code ? theme.colors.bg_surface_secondary : 'none'}
                minHeight="55px"
                width="100%"
                px={['4px', '4px', '12px', '12px']}
                py="8px"
                borderRadius={theme.radii.small}
              >
                <Box width={20} height={20}>
                  <Image src={item.thumnail} width={100} height={100} />
                </Box>

                <Column ml={theme.spacing.fix_100}>
                  <RowBetween>
                    <Text
                      fontSize={theme.typography.fontSizes.label_lg}
                      fontWeight={theme.typography.fontWeights.semibold}
                      lineHeight={theme.typography.lineHeights.label}
                    >
                      <Trans>{item.name}</Trans>
                    </Text>

                    {item.isWaitingClaim && (
                      <Box
                        width="6px"
                        height="6px"
                        background={colors.semantic_error}
                        borderRadius="50%"
                        ml={theme.spacing.fix_075}
                      />
                    )}
                  </RowBetween>
                  <Text
                    fontSize={theme.typography.fontSizes.label_sm}
                    fontWeight={theme.typography.fontWeights.semibold}
                    color={colors.fg_secondary}
                    mt={theme.spacing.fix_050}
                  >
                    <Trans>{item.description}</Trans>
                  </Text>
                </Column>
              </RowCenter>
            </Tab>
          )
        })}
      </RowCenter>
    </Box>
  )
}

export default PackageTabs
